<template>

    <div class="symbol">

        <div class="sort-during-scan" v-show="showSortDuringScan">
            <span class="text"><span class="bold">10/</span>80</span>
            <img src="/img/newsletters-v2/delete-orange-simple.svg" class="img__20">
        </div>

        <div class="deleted" v-show="showDeletedMails">
            <span>{{$t('help_new_mails_received')}}</span>
        </div>

        <div class="new-senders" v-show="showNewSenders">
            <div class="blue-point"></div>
            <span>{{$t('cleaning_sender')}}</span>
        </div>

        <div class="sort-later" v-show="showSortLater">
            <img src="/img/newsletters-v2/later.svg" class="img__16">
        </div>

        <div class="reverse-action" v-show="showReverseAction">
            <img src="/img/newsletters-v2/clock-blue.svg" class="img__16">
            <span>{{$t('reverse_action')}}</span>
        </div>

        <div class="actions" v-show="showActions">
            <img src="/img/help/actions/actions-symbol.svg">
        </div>

    </div>

</template>

<script>

import ENUM from '../../assets/ENUM'


export default {

    // Help Symbol in the focused feature pages
    name: 'help-symbol',

    props: {
        symbol: {
            type: String,
            default: ''
        }
    },

    computed: {

        showSortDuringScan() {
            return this.symbol === ENUM.HELP.FEATURES.SORT_DURING_SCAN
        },
        showDeletedMails() {
            return this.symbol === ENUM.HELP.FEATURES.DELETED_MAILS
        },
        showNewSenders() {
            return this.symbol === ENUM.HELP.FEATURES.NEW_SENDERS
        },
        showSortLater() {
            return this.symbol === ENUM.HELP.FEATURES.SORT_LATER
        },
        showReverseAction() {
            return this.symbol === ENUM.HELP.FEATURES.REVERSE_ACTION
        },
        showActions() {
            return this.symbol === ENUM.HELP.FEATURES.ACTIONS
        }

    },

    data() {
        return {

        }
    },

    methods: {

    }


}

</script>

<style lang="scss" scoped>

.symbol {
    display: flex;
    justify-content: center;

    .sort-during-scan {
        padding: 6px 12px;
        display: flex;
        align-items: center;
        background-color: $chardon;
        width: min-content;
        border-radius: 30px;
        .text {
            color: $sunset;
            font-size: 16px;
            font-weight: 400;
            .bold {
                font-weight: 600;
            }
        }
    }

    .deleted {
        padding: 6px 12px;
        display: flex;
        align-items: center;
        background-color: $chardon;
        width: min-content;
        border-radius: 30px;
        > span {
            color: $sunset;
            font-size: 17px;
            font-weight: 500;
            white-space: nowrap;
        }
    }

    .new-senders {
        display: flex;
        flex-direction: row;
        align-items: center;
        border-radius: 60px;
        background-color: $white;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08), 0px 8px 32px 0px rgba(0, 0, 0, 0.04);
        padding: 4px 10px;
        &:lang(ar-sa) {
            flex-direction: row-reverse;
        }

        .blue-point {
            width: 8px;
            height: 8px;
            border-radius: 8px;
            background-color: $aquamarine;
            margin-right: 8px;
            &:lang(ar-sa) {
                margin-right: 0;
                margin-left: 8px;
            }
        }
    }

    .sort-later {
        width: 32px;
        height: 32px;
        border-radius: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $aquamarine;
        border: 3px solid #BDE2F9;
    }

    .reverse-action {
        display: flex;
        flex-direction: row;
        padding: 6px 10px;
        border-radius: 32px;
        background: $white;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08), 0px 8px 32px 0px rgba(0, 0, 0, 0.04);
        > img {
            margin-right: 4px;
            &:lang(ar-sa) {
                margin-right: 0;
                margin-left: 4px;
            }
        }
    }

    .actions {
        > img {
            height: 32px;
        }
    }
}

</style>
